import React, { useContext, useEffect, useState } from "react";
import {
  Badge,
  Container,
  FormControl,
  Paper,
  Typography,
  Avatar,
  IconButton,
  Box,
  Skeleton,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Alert from "@mui/material/Alert";
import LinearProgress from "@mui/material/LinearProgress";
import Divider from "@mui/material/Divider";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import ColumnChart from "../../components/charts/ColumnChart";
import AreaChart from "../../components/charts/AreaChart";
import MenuIcon from "../../components/icons/MenuIcon";
import VerifyIcon from "../../components/icons/VerifyIcon";
import SecurityIcon from "../../components/icons/SecurityIcon";
import ListIcon2 from "../../components/icons/ListIcon2";
import MoneyIcon from "../../components/icons/MoneyIcon";
import UncompletedIcon from "../../components/icons/UncompletedIcon";
import FailedIcon from "../../components/icons/FailedIcon";
import FolderIcon from "../../components/icons/FolderIcon";
import DownloadIcon from "../../components/icons/DownloadIcon";
import MessageIcon from "../../components/icons/MessageIcon";
import MoonIcon from "../../components/icons/MoonIcon";
import { AuthContext } from "../../context/AuthContext";
import { getDataWithToken } from "../../services/GetDataService";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import jwt_decode, { jwtDecode } from "jwt-decode";
import Chart from "react-apexcharts";
import moment from "moment";
import CountUp from "react-countup";
// import makeStyles from "@mui/styles/makeStyles";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { PulseLoader, SyncLoader } from "react-spinners";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ButtonGroup from "@mui/material/ButtonGroup";
import { statusList } from "../../data";
import ColorPalette from "../../color-palette/ColorPalette";
import DashboardStockAlert from "./DashboardStockAlert";

// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
// const useStyles = makeStyles((theme) => ({
//   chartContainer: {
//     "& text": {
//       fill: theme.palette.text.light,
//     },
//     "& .apexcharts-title": {
//       fill: theme.palette.text.light,
//     },
//   },
// }));

const BranchDashboard = ({ toggleTheme }) => {
  const theme = useTheme();
  // const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);

  const [stats, setStats] = useState({});
  const [repairSummary, setRepairSummary] = useState({});
  const [repairChartSummary, setRepairChartSummary] = useState({});
  const [branchId, setBranchId] = useState("");
  const [message, setMessage] = useState("");
  const [startingTime, setStartingTime] = useState(dayjs().subtract(30, "day"));
  const [endingTime, setEndingTime] = useState(dayjs());
  const [repairStatusLoading, setRepairStatusLoading] = useState(false);
  const [repairStatusData, setRepairStatusData] = useState([]);

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const boxStyle = {
    background: "#fff",
    border: "1px solid #EAECF1",
    borderRadius: "12px",
    overflow: "hidden",
    padding: "16px 0",
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
  };
  const boxStyle2 = {
    background: "#fff",
    border: "1px solid #EAECF1",
    borderRadius: "12px",
    overflow: "hidden",
    padding: "16px 28px",
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    minWidth: "200px",
  };

  const getRepairStatusCount = async (formDate, toDate, branch) => {
    if (ifixit_admin_panel.token) {
      setRepairStatusLoading(true);

      let newBranch = branch;
      if (branch === "None") {
        newBranch = "";
      }

      const startDate = formDate ? dayjs(formDate).format("YYYY-MM-DD") : "";
      const endDate = toDate ? dayjs(toDate).format("YYYY-MM-DD") : "";

      // Build query params properly
      let url = `/api/v1/dashboard/repair-status-count?startDate=${startDate}&endDate=${endDate}`;

      if (newBranch) {
        url += `&branch_id=${newBranch}`;
      }

      let response = await getDataWithToken(url);

      if (response?.status === 401) {
        logout();
        return;
      }
      console.log("response?.data?.data 111111111", response?.data?.data);

      if (response.status >= 200 && response.status < 300) {
        setRepairStatusData(response?.data?.data);
      } else {
        handleSnakbarOpen(response?.data?.message, "error");
      }

      setRepairStatusLoading(false);
    }
  };

  useEffect(() => {
    if (ifixit_admin_panel?.user?.permission?.includes("dashboard")) {
      // getStats(startingTime, endingTime, branchId);
      // getRepairSummary();
      // getBranchList();
      getRepairStatusCount(startingTime, endingTime, branchId);
    }
    // getRepairSummaryForChart(months);
    // getSummaryOfaStore();
    // getStoreDetails();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    // setTimeout(() => setDisplay(true), 5);
  }, []);

  if (!ifixit_admin_panel?.user?.permission?.includes("dashboard")) {
    return <></>;
  }
  return (
    <>
      {/* <ColumnChart /> */}
      {/* {display && (
        <div id="chart">
          <Chart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={215}
          />
        </div>
      )} */}
      <Grid container alignItems="center" spacing={3} sx={{ mb: 3 }}>
        <Grid size={12}>
          <Box
            sx={{
              ...boxStyle,
            }}
          >
            {" "}
            {/* <Typography
              variant="base"
              color="text.main"
              sx={{ fontWeight: 500, ml: 4 }}
            >
              Summary
            </Typography> */}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ mb: 1.125, px: 3 }}
            >
              <Grid size={6}>
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  Last 30 Days Statistics
                </Typography>
              </Grid>
              <Grid size={6} sx={{ textAlign: "right" }}>
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="From Date"
                    value={startingTime}
                    onChange={(newValue) => {
                      getStats(newValue, endingTime, branchId);
                      setStartingTime(newValue);
                    }}
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        size: "small",
                        sx: { ...customeTextFeild },
                      }, // ✅ this is the correct way
                    }}
                  />
                </LocalizationProvider>
                &nbsp;&nbsp;&nbsp;
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="To Date"
                    value={endingTime}
                    onChange={(newValue) => {
                      getStats(startingTime, newValue, branchId);
                      setEndingTime(newValue);
                    }}
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        size: "small",
                        sx: { ...customeTextFeild },
                      }, // ✅ this is the correct way
                    }}
                  />
                </LocalizationProvider> */}
              </Grid>
            </Grid>
            {/* <Divider /> */}
            <Grid container spacing={2} sx={{ mt: 2.5, px: 3 }}>
              {statusList.length > 0 &&
                statusList.map((item, index) => (
                  <>
                    {/* <Grid size={3} key={index}>
                      <Box
                        sx={style.card}
                        style={{
                          backgroundColor: item.color,
                        }}
                        role="button"
                        // onClick={() => setRepairStatus(item.name)}
                      >
                        {item.icon}

                        <Typography variant="body1">{item.name}</Typography>
                      </Box>
                    </Grid> */}

                    <Grid
                      size={3}
                      sx={{
                        ...boxStyle2,
                      }}
                    >
                      {" "}
                      <Avatar
                        sx={{
                          width: 36,
                          height: 36,
                          bgcolor: `${item.color}`,
                          // bgcolor: `#FEF7C3`,
                        }}
                      >
                        {item.icon}
                      </Avatar>
                      <Typography
                        variant="medium"
                        color="text.light"
                        sx={{ fontWeight: 500, mt: 1 }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        variant="h6"
                        color="text.main"
                        sx={{ fontWeight: 600, margin: "0px" }}
                      >
                        <CountUp
                          end={repairStatusData?.[item.name] || 0}
                          duration={1}
                          // decimals={2}
                        />
                      </Typography>
                    </Grid>
                  </>
                ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <DashboardStockAlert />
    </>
  );
};

export default BranchDashboard;
